import { CHANGE_AUTHENTICATOR_VIEW } from "../types";

export default payload => ({
  type: CHANGE_AUTHENTICATOR_VIEW,
  payload
});
